import { useEffect, useState } from 'react';
import {
  CONSENT_DENIED,
  CONSENT_GRANTED,
  setConsent,
  shouldPromptForConsent,
} from 'helpers/consent';

/**
 * Cookie consent prompt for the store's Google tags and Meta Pixel.
 *
 * Only renders where consent is actually required (see helpers/consent.js) —
 * for an AU visitor this component returns null and nothing changes. The
 * decision is read once on mount rather than during render so the banner can't
 * flash on a visitor who has already chosen.
 */
export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(shouldPromptForConsent());
  }, []);

  if (!visible) return null;

  const choose = (state) => {
    setConsent(state);
    setVisible(false);
  };

  return (
    <div
      role='dialog'
      aria-live='polite'
      aria-label='Cookie consent'
      className='fixed bottom-0 left-0 right-0 z-[9999] border-t border-gray-200 bg-white p-4 shadow-lg'
    >
      <div className='mx-auto flex max-w-4xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
        <p className='text-sm leading-snug text-gray-700'>
          We use cookies to measure how our site is used and to improve your
          ordering experience. You can decline without affecting your order.
        </p>
        <div className='flex shrink-0 gap-2'>
          <button
            type='button'
            onClick={() => choose(CONSENT_DENIED)}
            className='rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700'
          >
            Decline
          </button>
          <button
            type='button'
            onClick={() => choose(CONSENT_GRANTED)}
            className='rounded-lg px-4 py-2 text-sm font-medium text-white'
            style={{ backgroundColor: 'var(--main-theme-color)' }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
